import React, { useState } from 'react';
import Image from 'next/image';
import { fixedPrice, isRetailer } from '../../../lib/bookstore-util';
import { getAttributeValue } from '../../../lib/attribute';
import BookstoreButton from '../bookstore-button';
import useThumbnails from '../../../hooks/use-thumbnails';

interface Props {
  cart: any;
  product: any;
  itemFormat?: string;
}

const BookstoreProduct: React.FC<Props> = ({ cart, product, itemFormat }) => {
  const thumbnails = useThumbnails(product.id);

  const [ratio, setRatio] = useState(16 / 9);

  return (
    <React.Fragment>
      <div className="product-item" key={product.id}>
        {thumbnails?.images ? (
          <React.Fragment>
            <div className="thumbnail">
              <Image
                height={280 / ratio}
                width={280}
                src={`${process.env.THUMBNAIL_URL}/${product.id}/${thumbnails.images[0].filename}`}
                onLoadingComplete={({ naturalWidth, naturalHeight }) => {
                  setRatio(naturalWidth / naturalHeight);
                }}
              />
            </div>
            <div className="thumbnail first">
              <h2>{product.name}</h2>
              <p>{product.sku}</p>
              {isRetailer(product.attributes) && (
                <p>
                  <strong>RETAILER ONLY</strong>
                </p>
              )}
              <p
                dangerouslySetInnerHTML={{
                  __html: getAttributeValue(
                    product.attributes,
                    'longdescription'
                  ),
                }}
              />
            </div>
            <div className="thumbnail second">
              <p>
                $
                {fixedPrice(getAttributeValue(product.attributes, 'itemprice'))}
              </p>
              <BookstoreButton
                cart={cart}
                product={product}
                overrideFormat={itemFormat}
              />
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className="first">
              <h2>{product.name}</h2>
              <p>{product.sku}</p>
              {isRetailer(product.attributes) && (
                <p>
                  <strong>RETAILER ONLY</strong>
                </p>
              )}
              <p
                dangerouslySetInnerHTML={{
                  __html: getAttributeValue(
                    product.attributes,
                    'longdescription'
                  ),
                }}
              />
            </div>
            <div className="second">
              <p>
                $
                {fixedPrice(getAttributeValue(product.attributes, 'itemprice'))}
              </p>
              <BookstoreButton
                cart={cart}
                product={product}
                overrideFormat={itemFormat}
              />
            </div>
          </React.Fragment>
        )}
      </div>
      {/* language=CSS */}
      <style jsx>{`
        .product-item {
          display: flex;
          flex: 1 0 100%;
        }

        @media screen and (max-width: 850px) {
          .product-item {
            flex-wrap: wrap;
            padding: 0 2rem;
          }
        }

        .product-item > .thumbnail {
          flex: 1 0 25%;
          position: relative;
          align-self: center;
        }

        @media screen and (max-width: 850px) {
          .product-item > .thumbnail {
            flex: 1 0 100%;
          }
        }

        .product-item > .first {
          flex: 1 0 80%;
          padding-right: 2rem;
        }

        .product-item > .thumbnail.first {
          flex: 1 0 55%;
        }

        @media screen and (max-width: 850px) {
          .product-item > .first {
            flex: 1 0 100%;
          }
        }

        .product-item > .second {
          flex: 1 0 20%;
          padding-left: 2rem;
        }

        @media screen and (max-width: 850px) {
          .product-item > .second {
            flex: 1 0 100%;
          }
        }

        .product-item h2 {
          font-family: 'Volvo Novum', sans-serif;
          font-weight: 500;
          font-size: 18px;
        }

        .product-item p {
          font-family: 'Volvo Novum', sans-serif;
          font-weight: 400;
          font-size: 14px;
        }
      `}</style>
    </React.Fragment>
  );
};

export default BookstoreProduct;
